module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "fm_title",
    attrs: {
      "id": "gloss"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("GLOSSARY")])]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/06_Chapter01#gloss_1",
      "id": "rgloss_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CCP")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Chinese Communist Party")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Introduction#gloss_2",
      "id": "rgloss_2"
    }
  }, [_vm._v("CIA")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Central Intelligence Agency (US)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Introduction#gloss_3",
      "id": "rgloss_3"
    }
  }, [_vm._v("CPVA")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Chinese People’s Volunteer Army")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1",
    attrs: {
      "id": "gloss_4"
    }
  }, [_vm._v("DPRK")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Democratic People’s Republic of Korea (North Korea)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1",
    attrs: {
      "id": "rgloss_5"
    }
  }, [_vm._v("EUSAK")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Eighth United States Army in Korea")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/07_Chapter02#gloss_6",
      "id": "rgloss_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FAB")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("field artillery battalion")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Introduction#gloss_7",
      "id": "rgloss_7"
    }
  }, [_vm._v("FEAF")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Far East Air Forces (US)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_Chapter03#gloss_8",
      "id": "rgloss_8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("GIAP")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Guards Interceptor Air Regiment (Soviet)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1",
    attrs: {
      "id": "rgloss_9"
    }
  }, [_vm._v("HE")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("high explosive")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_Chapter03#gloss_10",
      "id": "rgloss_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IAD")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Interceptor–fighter Air Division (Soviet)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_Chapter03#gloss_11",
      "id": "rgloss_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IAK")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Fighter Air Corps (Soviet)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_Chapter03#gloss_12",
      "id": "rgloss_12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IAP")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Interceptor–fighter Air Regiment")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_Chapter03#gloss_13",
      "id": "rgloss_13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JOC")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Joint Operations Centre")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_Chapter03#gloss_14",
      "id": "rgloss_14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JCS")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Joint Chiefs of Staff (US)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1",
    attrs: {
      "id": "rgloss_15"
    }
  }, [_vm._v("KATUSA")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Korean Augmentation to the US Army")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/07_Chapter02#gloss_16",
      "id": "rgloss_16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("KMAG")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Korea Military Advisory Group (US)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Introduction#gloss_17",
      "id": "rgloss_17"
    }
  }, [_vm._v("KPA")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Korean People’s Army (North Korean)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1",
    attrs: {
      "id": "rgloss_18"
    }
  }, [_vm._v("MLR")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("main line of resistance")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter05#gloss_19",
      "id": "rgloss_19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MSR")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("main supply route")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Introduction#gloss_20",
      "id": "rgloss_20"
    }
  }, [_vm._v("PLA")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("People’s Liberation Army (China)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_Chapter03#gloss_21",
      "id": "rgloss_21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PLAAF")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("People’s Liberation Army Air Force (China)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Introduction#gloss_22",
      "id": "rgloss_22"
    }
  }, [_vm._v("PRC")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("People’s Republic of China")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter04#gloss_23",
      "id": "rgloss_23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RCT")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Regimental Combat Team")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/07_Chapter02#gloss_24",
      "id": "rgloss_24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ROK")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Republic of Korea (South Korea)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Introduction#gloss_25",
      "id": "rgloss_25"
    }
  }, [_vm._v("ROKA")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Republic of Korea Army (South Korean)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1",
    attrs: {
      "id": "rgloss_26"
    }
  }, [_vm._v("TF")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("task force")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1",
    attrs: {
      "id": "rgloss_27"
    }
  }, [_vm._v("UNC")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("United Nations Command")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/06_Chapter01#gloss_28",
      "id": "rgloss_28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("USMC")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("United States Marine Corps")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("It will be noticed that many Korean names of places and geographical features either carry the same suffix or end in the same few letters. These define what a name is being applied to, e.g. Ch’ŏng"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ch’ŏn")]), _vm._v(" would be Ch’ŏng River: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ch’ŏn")]), _vm._v(" or "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("gang")]), _vm._v(" river; "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("do")]), _vm._v(" island; "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("dong")]), _vm._v(" town or village within a district or "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ri")]), _vm._v("; "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ni")]), _vm._v(" town; "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ri")]), _vm._v(" town and surrounding district; "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("san")]), _vm._v(" mountain.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e09250e8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/03_Glossary.vue
// module id = 66
// module chunks = 0